import Content from "../content";
import ContentfulClient from "../lib/contentful_client/ContentfulClient";
import Head from "next/head";
import Settings from "../settings";
import ShoppingHeader from "../components/cart/ShoppingHeader";

function FAQ({ content }) {
  return (
    <ContentPage title="Shipping and Returns" content={content}></ContentPage>
  );
}

FAQ.displayName = "FAQ";
export default FAQ;

export async function getStaticProps(context) {
  const content = await ContentfulClient.getPageContent("pagesMisc", [
    "shippingAndReturns",
  ]);

  return {
    props: {
      content: content["shippingAndReturns"],
    },
    revalidate: Settings.revalidate,
  };
}

function ContentPage({
  title,
  content,
  children,
  listSpacing,
}: {
  title?: string;
  content: any;
  children?: any;
  listSpacing?: string;
}) {
  if (title) {
    return (
      <>
        <Head>
          <title>
            {title} | {Content.siteName}
          </title>
        </Head>
        <ShoppingHeader title={title} containerClass="container" />
        <section className={`container w-full pb-24 flex`}>
          <div
            className="contentful-content max-w-4xl"
            dangerouslySetInnerHTML={{ __html: content }}
          />
          {children}
        </section>
      </>
    );
  }
  return (
    <>
      <div
        className="cw-100 d-flex flex-column flex-items-center flex-justify-center"
        style={{
          paddingTop: "calc(var(--nav-height))",
        }}
      >
        <section
          className={`cw-100 d-flex flex-column flex-items-center flex-justify-center z-1 py-12 md:py-24 h-clr-accent p-t4 ul-t4`}
        >
          <div
            className={`content-prose h-clr-accent show-list-markers ${
              listSpacing || "list-spacing-2"
            }`}
            dangerouslySetInnerHTML={{ __html: content }}
          />
          {children}
        </section>
      </div>
    </>
  );
}
